import { isEmpty } from '.';
import {
  DOCKET_PRINTER_TYPES,
  PRINTER_FONT_SIZES,
  PRINTER_ROLLS,
  PRINTER_TYPE_BLUETOOTH,
  PRINTER_TYPE_WIFI,
  STICKER_PRINTER_TYPES,
} from '../config/constants/printerProfiles';

export const mapProfile = p => {
  const PRINTER_TYPES = p.sticker_printer_enabled
    ? STICKER_PRINTER_TYPES
    : DOCKET_PRINTER_TYPES;

  const mp = {
    ...p,
    rollType: PRINTER_ROLLS.find(r => r.id === p.roll_id),
    font: PRINTER_FONT_SIZES.find(f => f.id === p.font_id),
    printerType: PRINTER_TYPES.find(t => t.id === p.type_id),
  };

  mp.printerChildType = !isEmpty(mp.printerType?.childTypes)
    ? mp.printerType?.childTypes.find(c => c.id === p[mp.printerType?.childKey])
    : null;

  return mp;
};

export const unmapProfile = p => {
  const mp = { ...p };

  mp.roll_id = p.rollType.id;
  mp.font_id = p.font.id;
  mp.type_id = p.printerType?.id;

  delete mp.rollType;
  delete mp.font;
  delete mp.printerType;
  delete mp.printerChildType;

  if (!isEmpty(p.printerChildType)) {
    if (PRINTER_TYPE_BLUETOOTH.id === mp.type_id) {
      delete mp.network_printer_id;
      mp[p.printerType?.childKey] = p.printerChildType?.id;
    } else if (PRINTER_TYPE_WIFI.id === mp.type_id) {
      delete mp.bluetooth_printer_id;
      mp[p.printerType?.childKey] = p.printerChildType?.id;
    }
  } else {
    delete mp.network_printer_id;
    delete mp.bluetooth_printer_id;
  }

  if (!p.docket_customer_copy_enabled) {
    mp.docket_customer_copy_count = 0;
  }

  if (!p.docket_kitchen_copy_enabled) {
    mp.docket_kitchen_copy_count = 0;
  }

  return mp;
};

export default { mapProfile };
